import { render, staticRenderFns } from "./SluzbaDetail.vue?vue&type=template&id=84e38636&scoped=true&"
import script from "./SluzbaDetail.vue?vue&type=script&lang=js&"
export * from "./SluzbaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e38636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84e38636')) {
      api.createRecord('84e38636', component.options)
    } else {
      api.reload('84e38636', component.options)
    }
    module.hot.accept("./SluzbaDetail.vue?vue&type=template&id=84e38636&scoped=true&", function () {
      api.rerender('84e38636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/SluzbaDetail.vue"
export default component.exports